import {CircularProgress, Dialog, DialogContent, Stack, Typography} from '@mui/material';
import React from 'react';

import {translations} from 'presentation/translations-new';
import {dialogPaperProps} from './styles';

const {label} =
	translations['pt-br'].privateFlow.refund.previewServiceType.proceduresForm.processingModal;

interface ProcessingModalProps {
	open: boolean;
}

export function ProcessingModal({open}: ProcessingModalProps) {
	return (
		<Dialog open={open} slotProps={{paper: dialogPaperProps}}>
			<DialogContent sx={{padding: 0}}>
				<Stack alignItems="center" gap={2} height="100%" padding={0} justifyContent="center">
					<CircularProgress color="primary" size={32} />
					<Typography variant="body1" color="text.secondary" fontWeight={600}>
						{label}
					</Typography>
				</Stack>
			</DialogContent>
		</Dialog>
	);
}
